import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { I18nProvider as RaI18nProvider } from 'react-admin';
import englishMessages from 'ra-language-english';
import frenchMessages from 'ra-language-french';
import { bloxEnglishMessages } from './Languages/english';
import { bloxSpanishMessages } from './Languages/spanish';
import { bloxFrenchMessages } from './Languages/french';

// Initialize i18next once. The guard makes this safe for tests that import
// this module after a separate test bootstrap has already initialized i18next
// (and have mocked react-i18next, which would otherwise make the .use() call
// throw on re-import).
if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        ...bloxEnglishMessages,
        ...englishMessages,
      },
    },
    es: {
      translation: {
        ...bloxSpanishMessages,
        // No ra spanish language package available
      },
    },
    fr: {
      translation: {
        ...bloxFrenchMessages,
        ...frenchMessages,
      },
    },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
    format(value, format, lng) {
      /**
       * handle {{ names, list }} when an array
       * eg: "Requires {{ names, list }} permissions"
       * result: "req p1, p2, and p3" / "req p1 and p2"
       */
      if (format === 'list' && Array.isArray(value)) {
        return new Intl.ListFormat(lng, {
          style: 'long',
          type: 'conjunction',
        }).format(value);
      }
      return value;
    },
  },
  });
}

export const i18nProvider: RaI18nProvider = {
  translate: (key: string, options?: Record<string, unknown>): string => {
    return i18n.t(key, options);
  },
  changeLocale: async (locale: string): Promise<void> => {
    await i18n.changeLanguage(locale);
  },
  getLocale: (): string => i18n.language,
};

export default i18nProvider;

/**
 * Note, in CMSADMIN-983 noticed there are some issues if exporting a constant
 * e.g. `const export mediaLibLabel = 'blox.medialibrary.label';` to re-use
 * and importing it in other areas of the codebase where using t(mediaLibLabel)
 * The code splitting / variable hoisting was not working correctly and crashing
 * certain screens. For safety, recommend using the string literals and not
 * exporting constants for i18n keys.
 */
